/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PlannerAppResourceReadRequest,
  PlannerAppResourceReadResponse,
  PlannerAppToolCallRequest,
  PlannerAppToolCallResponse,
  PlannerChatRequest,
  PlannerDeleteResponse,
  PlannerItineraryReorderRequest,
  PlannerItineraryResponse,
  PlannerPromotionStartRequest,
  PlannerReviewRequest,
  PlannerSessionDetailResponse,
  PlannerSessionListResponse,
  PlannerSessionResponse,
  PlannerSessionUpdateRequest,
} from '../models/index';
import {
    PlannerAppResourceReadRequestFromJSON,
    PlannerAppResourceReadRequestToJSON,
    PlannerAppResourceReadResponseFromJSON,
    PlannerAppResourceReadResponseToJSON,
    PlannerAppToolCallRequestFromJSON,
    PlannerAppToolCallRequestToJSON,
    PlannerAppToolCallResponseFromJSON,
    PlannerAppToolCallResponseToJSON,
    PlannerChatRequestFromJSON,
    PlannerChatRequestToJSON,
    PlannerDeleteResponseFromJSON,
    PlannerDeleteResponseToJSON,
    PlannerItineraryReorderRequestFromJSON,
    PlannerItineraryReorderRequestToJSON,
    PlannerItineraryResponseFromJSON,
    PlannerItineraryResponseToJSON,
    PlannerPromotionStartRequestFromJSON,
    PlannerPromotionStartRequestToJSON,
    PlannerReviewRequestFromJSON,
    PlannerReviewRequestToJSON,
    PlannerSessionDetailResponseFromJSON,
    PlannerSessionDetailResponseToJSON,
    PlannerSessionListResponseFromJSON,
    PlannerSessionListResponseToJSON,
    PlannerSessionResponseFromJSON,
    PlannerSessionResponseToJSON,
    PlannerSessionUpdateRequestFromJSON,
    PlannerSessionUpdateRequestToJSON,
} from '../models/index';

export interface PlannerAppsResourcesReadPostRequest {
    plannerAppResourceReadRequest: PlannerAppResourceReadRequest;
}

export interface PlannerAppsToolsCallPostRequest {
    plannerAppToolCallRequest: PlannerAppToolCallRequest;
}

export interface PlannerChatPostRequest {
    plannerChatRequest: PlannerChatRequest;
}

export interface PlannerPromotionsStartPostRequest {
    plannerPromotionStartRequest: PlannerPromotionStartRequest;
}

export interface PlannerReviewPostRequest {
    plannerReviewRequest: PlannerReviewRequest;
}

export interface PlannerSessionDeleteRequest {
    sessionId: string;
}

export interface PlannerSessionEventsStreamGetRequest {
    sessionId: string;
    afterSequence?: number;
}

export interface PlannerSessionGetRequest {
    sessionId: string;
}

export interface PlannerSessionItineraryGetRequest {
    sessionId: string;
}

export interface PlannerSessionItineraryPatchRequest {
    sessionId: string;
    plannerItineraryReorderRequest: PlannerItineraryReorderRequest;
}

export interface PlannerSessionPatchRequest {
    sessionId: string;
    plannerSessionUpdateRequest: PlannerSessionUpdateRequest;
}

/**
 * 
 */
export class PlannerApi extends runtime.BaseAPI {

    /**
     * Read one Gondola MCP App view (`ui://gondola/...`) for the authenticated user\'s concierge. Only allowlisted users and fixed view URIs are accepted (GON-7817).
     */
    async plannerAppsResourcesReadPostRaw(requestParameters: PlannerAppsResourcesReadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannerAppResourceReadResponse>> {
        if (requestParameters['plannerAppResourceReadRequest'] == null) {
            throw new runtime.RequiredError(
                'plannerAppResourceReadRequest',
                'Required parameter "plannerAppResourceReadRequest" was null or undefined when calling plannerAppsResourcesReadPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/apps/resources/read`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlannerAppResourceReadRequestToJSON(requestParameters['plannerAppResourceReadRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlannerAppResourceReadResponseFromJSON(jsonValue));
    }

    /**
     * Read one Gondola MCP App view (`ui://gondola/...`) for the authenticated user\'s concierge. Only allowlisted users and fixed view URIs are accepted (GON-7817).
     */
    async plannerAppsResourcesReadPost(requestParameters: PlannerAppsResourcesReadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannerAppResourceReadResponse> {
        const response = await this.plannerAppsResourcesReadPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Run one read-only MCP tool on behalf of an MCP App view in the authenticated user\'s concierge. Only allowlisted users and `search_hotels_v2` are accepted (GON-7817).
     */
    async plannerAppsToolsCallPostRaw(requestParameters: PlannerAppsToolsCallPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannerAppToolCallResponse>> {
        if (requestParameters['plannerAppToolCallRequest'] == null) {
            throw new runtime.RequiredError(
                'plannerAppToolCallRequest',
                'Required parameter "plannerAppToolCallRequest" was null or undefined when calling plannerAppsToolsCallPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/apps/tools/call`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlannerAppToolCallRequestToJSON(requestParameters['plannerAppToolCallRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlannerAppToolCallResponseFromJSON(jsonValue));
    }

    /**
     * Run one read-only MCP tool on behalf of an MCP App view in the authenticated user\'s concierge. Only allowlisted users and `search_hotels_v2` are accepted (GON-7817).
     */
    async plannerAppsToolsCallPost(requestParameters: PlannerAppsToolsCallPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannerAppToolCallResponse> {
        const response = await this.plannerAppsToolsCallPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * SSE streaming endpoint for travel planner chat
     */
    async plannerChatPostRaw(requestParameters: PlannerChatPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['plannerChatRequest'] == null) {
            throw new runtime.RequiredError(
                'plannerChatRequest',
                'Required parameter "plannerChatRequest" was null or undefined when calling plannerChatPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/chat`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlannerChatRequestToJSON(requestParameters['plannerChatRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * SSE streaming endpoint for travel planner chat
     */
    async plannerChatPost(requestParameters: PlannerChatPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.plannerChatPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Best-effort warmup for the authenticated user\'s next planning conversation
     */
    async plannerPrewarmPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/prewarm`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Best-effort warmup for the authenticated user\'s next planning conversation
     */
    async plannerPrewarmPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.plannerPrewarmPostRaw(initOverrides);
    }

    /**
     * Start or replay an authenticated promotions conversation with a fixed prompt.
     */
    async plannerPromotionsStartPostRaw(requestParameters: PlannerPromotionsStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['plannerPromotionStartRequest'] == null) {
            throw new runtime.RequiredError(
                'plannerPromotionStartRequest',
                'Required parameter "plannerPromotionStartRequest" was null or undefined when calling plannerPromotionsStartPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/promotions/start`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlannerPromotionStartRequestToJSON(requestParameters['plannerPromotionStartRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Start or replay an authenticated promotions conversation with a fixed prompt.
     */
    async plannerPromotionsStartPost(requestParameters: PlannerPromotionsStartPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.plannerPromotionsStartPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a post-trip review session for a completed booking
     */
    async plannerReviewPostRaw(requestParameters: PlannerReviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannerSessionResponse>> {
        if (requestParameters['plannerReviewRequest'] == null) {
            throw new runtime.RequiredError(
                'plannerReviewRequest',
                'Required parameter "plannerReviewRequest" was null or undefined when calling plannerReviewPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/review`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlannerReviewRequestToJSON(requestParameters['plannerReviewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlannerSessionResponseFromJSON(jsonValue));
    }

    /**
     * Create a post-trip review session for a completed booking
     */
    async plannerReviewPost(requestParameters: PlannerReviewPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannerSessionResponse> {
        const response = await this.plannerReviewPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a planner session
     */
    async plannerSessionDeleteRaw(requestParameters: PlannerSessionDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannerDeleteResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling plannerSessionDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/sessions/{session_id}`;
        urlPath = urlPath.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlannerDeleteResponseFromJSON(jsonValue));
    }

    /**
     * Delete a planner session
     */
    async plannerSessionDelete(requestParameters: PlannerSessionDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannerDeleteResponse> {
        const response = await this.plannerSessionDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resumable server-sent-events stream for planner session client events
     */
    async plannerSessionEventsStreamGetRaw(requestParameters: PlannerSessionEventsStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling plannerSessionEventsStreamGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['afterSequence'] != null) {
            queryParameters['after_sequence'] = requestParameters['afterSequence'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/sessions/{session_id}/events/stream`;
        urlPath = urlPath.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Resumable server-sent-events stream for planner session client events
     */
    async plannerSessionEventsStreamGet(requestParameters: PlannerSessionEventsStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.plannerSessionEventsStreamGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a planner session with all messages
     */
    async plannerSessionGetRaw(requestParameters: PlannerSessionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannerSessionDetailResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling plannerSessionGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/sessions/{session_id}`;
        urlPath = urlPath.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlannerSessionDetailResponseFromJSON(jsonValue));
    }

    /**
     * Get a planner session with all messages
     */
    async plannerSessionGet(requestParameters: PlannerSessionGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannerSessionDetailResponse> {
        const response = await this.plannerSessionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get itinerary items for a planner session
     */
    async plannerSessionItineraryGetRaw(requestParameters: PlannerSessionItineraryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannerItineraryResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling plannerSessionItineraryGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/sessions/{session_id}/itinerary`;
        urlPath = urlPath.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlannerItineraryResponseFromJSON(jsonValue));
    }

    /**
     * Get itinerary items for a planner session
     */
    async plannerSessionItineraryGet(requestParameters: PlannerSessionItineraryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannerItineraryResponse> {
        const response = await this.plannerSessionItineraryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reorder itinerary items for a planner session
     */
    async plannerSessionItineraryPatchRaw(requestParameters: PlannerSessionItineraryPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannerItineraryResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling plannerSessionItineraryPatch().'
            );
        }

        if (requestParameters['plannerItineraryReorderRequest'] == null) {
            throw new runtime.RequiredError(
                'plannerItineraryReorderRequest',
                'Required parameter "plannerItineraryReorderRequest" was null or undefined when calling plannerSessionItineraryPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/sessions/{session_id}/itinerary`;
        urlPath = urlPath.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlannerItineraryReorderRequestToJSON(requestParameters['plannerItineraryReorderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlannerItineraryResponseFromJSON(jsonValue));
    }

    /**
     * Reorder itinerary items for a planner session
     */
    async plannerSessionItineraryPatch(requestParameters: PlannerSessionItineraryPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannerItineraryResponse> {
        const response = await this.plannerSessionItineraryPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a planner session name
     */
    async plannerSessionPatchRaw(requestParameters: PlannerSessionPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannerSessionResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling plannerSessionPatch().'
            );
        }

        if (requestParameters['plannerSessionUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'plannerSessionUpdateRequest',
                'Required parameter "plannerSessionUpdateRequest" was null or undefined when calling plannerSessionPatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/sessions/{session_id}`;
        urlPath = urlPath.replace(`{${"session_id"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlannerSessionUpdateRequestToJSON(requestParameters['plannerSessionUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlannerSessionResponseFromJSON(jsonValue));
    }

    /**
     * Update a planner session name
     */
    async plannerSessionPatch(requestParameters: PlannerSessionPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannerSessionResponse> {
        const response = await this.plannerSessionPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List the user\'s planner sessions
     */
    async plannerSessionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlannerSessionListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/planner/sessions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlannerSessionListResponseFromJSON(jsonValue));
    }

    /**
     * List the user\'s planner sessions
     */
    async plannerSessionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlannerSessionListResponse> {
        const response = await this.plannerSessionsGetRaw(initOverrides);
        return await response.value();
    }

}
